const homePageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      "@id": "https://harisharandevgan.com/#person",
      "name": "Harisharan Devgan",
      "url": "https://harisharandevgan.com/",
      "image": [
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-iit-kanpur.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-iit-kanpur.jpg",
          "caption": "IIT Kanpur & NAPL Collaboration For Research On Cannabis",
          "description": "MOU signed between Niche Agriculture & Pharmaceuticals Limited and IIT kanpur for research on cannabis cultivars and cultivation techniques."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-farmer-education.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-farmer-education.jpg",
          "caption": "Supporting The Youth By Providing Educational Support",
          "description": "Harisharan Devgan, an agriculturist, supporting farmer’s children and families through financial and emotional support, focused actively on providing education and future opportunities to farmer’s children."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-msme-startup.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-msme-startup.jpg",
          "caption": "Tajurba Msme & Startup Conclave",
          "description": "Harisharan Devgan receiving recognition for entrepreneurship and agricultural innovation at Tajurba msme & startup conclave."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-modern-farming.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-modern-farming.jpg",
          "caption": "Guiding Farmers Towards Modern Farming",
          "description": "Harisharan Devgan guiding farmers to embrace modern, technology-driven, and sustainable farming practices in hilly areas."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-organic-farming.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-organic-farming.jpg",
          "caption": "Entrepreneur Of The Year – “Organic Farmer”",
          "description": "Harisharan Devgan, agriculturist, receiving the ‘Entrepreneur of the Year’ award for his contribution towards organic and sustainable farming."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-animal-welfare.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-animal-welfare.jpg",
          "caption": "Animal Enthusiast",
          "description": "Harisharan Devgan demonstrating his commitment to animal welfare and protection."
        },
        {
          "@type": "ImageObject",
          "url": "https://harisharandevgan.com/img/harisharan-devgan-aakashwani-farming.jpg",
          "contentUrl": "https://harisharandevgan.com/img/harisharan-devgan-aakashwani-farming.jpg",
          "caption": "Aakashwani-discussion On Farming",
          "description": "Harisharan Devgan sharing insights on agriculture, farming practices, social welfare, and the political state of the country during an Aakashwani discussion."
        },
        {
          "@type": "ImageObject",
          "url": "https://blog.harisharandevgan.com/wp-content/uploads/2026/08/harisharan-devgan-jpsc-press-conference-1024x575.png",
          "contentUrl": "https://blog.harisharandevgan.com/wp-content/uploads/2026/08/harisharan-devgan-jpsc-press-conference-1024x575.png",
          "caption": "A Social Movement For Justice In The JPSC Issue",
          "description": "Harisharan Devgan, an agriculturist with a political voice, filed a Public Interest Litigation, (PIL) in the Supreme Court of India, seeking an independent CBI investigation into the JPSC and JSSC examinations in Jharkhand, and launched #JharkhandStudentUnity to provide a unified platform for students facing FIRs or legal cases related to peaceful protests."
        },
        {
          "@type": "ImageObject",
          "url": [
            "https://harisharandevgan.com/img/harisharan-devgan-office-meeting.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-sitting-in-office.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-office-portrait.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-csk-hpau-palampur.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-csk-hp-agricultural-university-palampur.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-jpsc-exam-row-supreme-court.jpg",
            "https://harisharandevgan.com/img/jpsc-prelims-2025-supreme-court-pil.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-with-jpsc-students.jpg"
          ],
          "contentUrl": [
            "https://harisharandevgan.com/img/harisharan-devgan-office-meeting.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-sitting-in-office.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-office-portrait.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-csk-hpau-palampur.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-csk-hp-agricultural-university-palampur.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-jpsc-exam-row-supreme-court.jpg",
            "https://harisharandevgan.com/img/jpsc-prelims-2025-supreme-court-pil.jpg",
            "https://harisharandevgan.com/img/harisharan-devgan-with-jpsc-students.jpg"
          ],
          "caption": "Profile Portrait",
          "description": "A formal portrait of Harisharan Devgan, used for various social media and other online platforms as profile picture, reflecting his confident presence, strong personality, and leadership stance."
        }
      ],
      "description": "Agriculturist with political voice, Rooted in the Farm Lands, Fighting for the common man, Following the ideology of Bharat Ratna MS Swaminathan.",
      "birthDate": "1974-08-25",
      "gender": "Male",
      "nationality": {
        "@type": "Country",
        "name": "India"
      },
      "birthPlace": {
        "@type": "Place",
        "name": "Mumbai, India"
      },
      "email": "mail@harisharandevgan.com",
      "jobTitle": [
        "Agriculturist",
        "Social Activist",
        "Chairman",
        "Public Figure",
        "Petitioner",
        "Political Activist",
        "Public Affairs Leader"
      ],
      "sameAs": [
        "https://www.facebook.com/Harisharaandevgan/",
        "https://x.com/harisharandevgn",
        "https://www.instagram.com/harisharandevgan/",
        "https://www.youtube.com/@harisharandevgan",
        "https://www.linkedin.com/in/harisharandevgan/",
        "https://in.pinterest.com/harisharandevgan/",
        "https://github.com/harisharandevgan",
        "https://profile.google.com/cp/Cg0vZy8xMXEyeHM4YzR2"
      ],
      "knowsAbout": [
        "Organic Farming",
        "Sustainable Agriculture",
        "Water Management",
        "Renewable Energy",
        "Phytopharmaceuticals",
        "Biofertilizers",
        "Public Welfare Issues",
        "Politics",
        "Public Interest Litigation (PIL)"
      ],
      "knowsLanguage": [
        "Hindi",
        "English",
        "Punjabi",
        "Marathi",
        "Gujarati",
        "Kannada",
        "Telugu"
      ],
      "award": "Entrepreneur of the Year (Organic Farming)",
      "worksFor": [
        {
          "@id": "https://nichegroup.info/#org"
        },
        {
          "@id": "https://naplimited.com/#org"
        },
        {
          "@id": "https://niblimited.com/#org"
        },
        {
          "@id": "https://www.nicheagriculture.com/#org"
        }
      ],
      "spouse": {
        "@type": "Person",
        "name": "Pragya Devgan"
      },
      "children": [
        {
          "@type": "Person",
          "name": "Ritvik Devgan"
        },
        {
          "@type": "Person",
          "name": "Swastik Devgan"
        }
      ],
      "identifier": {
        "@type": "PropertyValue",
        "name": "Google Knowledge Graph ID",
        "value": "/g/11q2xs8c4v",
        "url": "https://www.google.com/search?kgmid=/g/11q2xs8c4v"
      },
      "mainEntityOfPage": {
        "@id": "https://harisharandevgan.com/#profilepage"
      }
    },
    {
      "@type": "ProfilePage",
      "@id": "https://harisharandevgan.com/#profilepage",
      "url": "https://harisharandevgan.com/",
      "name": "Harisharan Devgan",
      "headline": "Agriculturist with Political Voice",
      "mainEntity": {
        "@id": "https://harisharandevgan.com/#person"
      },
      "isPartOf": {
        "@id": "https://harisharandevgan.com/#website"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://harisharandevgan.com/#website",
      "url": "https://harisharandevgan.com/",
      "name": "Harisharan Devgan",
      "publisher": {
        "@id": "https://harisharandevgan.com/#person"
      }
    },
    {
      "@type": "Organization",
      "@id": "https://nichegroup.info/#org",
      "name": "Niche Group",
      "url": "https://nichegroup.info/",
      "description": "Discover the Niche Group, a diverse portfolio led by visionary Harisharan Devgan. From Organic Farming to Renewable Energy and Social Welfare to Politics, we prioritize sustainability and innovation."
    },
    {
      "@type": "Organization",
      "@id": "https://naplimited.com/#org",
      "name": "Niche Agriculture and Pharmaceuticals Limited",
      "url": "https://naplimited.com/",
      "description": "Company focused on agriculture innovation, pharmaceuticals, and sustainable farming solutions."
    },
    {
      "@type": "Organization",
      "@id": "https://niblimited.com/#org",
      "name": "Niche Infotech and Biotech Private Limited",
      "url": "https://niblimited.com/",
      "description": "Company working in biotechnology and information technology solutions."
    },
    {
      "@type": "Organization",
      "@id": "https://www.nicheagriculture.com/#org",
      "name": "Niche Agriculture",
      "url": "https://www.nicheagriculture.com/",
      "description": "Agriculture-focused initiative supporting organic farming and sustainability."
    }
  ]
};

export default homePageSchema;
